import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get, patch, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

// Code below referred from Spire Prod 
// export interface FileCollection {
//     fileName: string;
//     fileContentBase64: string;
// }

export interface QuoteProductsList {
    quantity: string;
    adiNumber: string;
    details: string;
    // added below propery is the P21 Change ---- P21 Change
    properties:{
        isValidProduct:string;
        ProductType:string;
    }

}

export interface GetSubmitRequestQuoteApiParameter extends ApiParameter {
    contactName: string;
    email: string;
    phoneNumber: string;
    projectName: string;
    quoteProductsList: QuoteProductsList[];
    notes: string;
    dcEmail: string;
    // fileCollection: FileCollection[]; --> Code referred from Spire Prod
    companyName: string;
    customerNumber: string;
    // Added below properites are P21 Change ---- P21 Change
    sourceLocationID: string;
    salesLocation: string;
    onComplete?: (onSubmitDataResponse: any) => void;


}

export interface SubmitRequestQuoteModel extends BaseModel {}


// api/v1/requestQuote/SubmitRequestQuote
const url = "api/v1/requestQuote";

export async function getSubmitRequestQuote(
    parameter: GetSubmitRequestQuoteApiParameter,
): Promise<ServiceResult<SubmitRequestQuoteModel>> {
    try {
        const getSubmitRequestQuote = await patch<SubmitRequestQuoteModel>(
            `${url}/SubmitRequestQuote`,
            parameter as any,
        );
        return {
            result: getSubmitRequestQuote,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
